module.exports = __webpack_public_path__ + "img/weitongguo.65b2ec32.png";